/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createLog } from '../../factoriesNumber.js';
export var logDependencies = {
  typedDependencies,
  createLog
};